import type { SVGProps } from "react";

/**
 * Filled three-dot "more options" glyph, matching the Storybook Final `MoreDots`
 * and the agent grid card. Aliased as `MoreHorizontal` in `icons.ts` so every
 * row-actions trigger renders solid dots instead of the outline iconsax `More`.
 */
export function MoreDots(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      <circle cx="5" cy="12" r="1.6" />
      <circle cx="12" cy="12" r="1.6" />
      <circle cx="19" cy="12" r="1.6" />
    </svg>
  );
}
